import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Ícones de linha, desenhados no mesmo traço para manter a interface coerente. */
const COMUM = {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.3,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
};
export function IconeCamadas() {
    return (_jsxs("svg", { ...COMUM, children: [_jsx("path", { d: "M7 1.6 12.6 4.6 7 7.6 1.4 4.6 7 1.6Z" }), _jsx("path", { d: "M1.4 7.4 7 10.4l5.6-3" }), _jsx("path", { d: "M1.4 10.2 7 13.2l5.6-3" })] }));
}
export function IconeInicio() {
    return (_jsxs("svg", { ...COMUM, children: [_jsx("path", { d: "M2.4 6.6 7 2.4l4.6 4.2" }), _jsx("path", { d: "M3.6 6v5.6h2.6V9h1.6v2.6h2.6V6" })] }));
}
export function IconeIngestao() {
    return (_jsxs("svg", { ...COMUM, children: [_jsx("path", { d: "M7 1.6v8.4" }), _jsx("path", { d: "m3.6 6.4 3.4 3.6 3.4-3.6" }), _jsx("path", { d: "M2.2 12.4h9.6" })] }));
}
export function IconeMapa() {
    return (_jsxs("svg", { ...COMUM, children: [_jsx("path", { d: "M1.6 3.2 5 4.6l4-1.4L12.4 2v8.4L9 11.8l-4 1.4L1.6 12Z" }), _jsx("path", { d: "M5 4.6v8.6M9 3.2v8.6" })] }));
}
export function IconeBusca() {
    return (_jsxs("svg", { ...COMUM, width: 12, height: 12, viewBox: "0 0 12 12", children: [_jsx("circle", { cx: "5.2", cy: "5.2", r: "3.6" }), _jsx("path", { d: "M8 8l2.4 2.4" })] }));
}
export function IconeRecolher() {
    return (_jsx("svg", { ...COMUM, children: _jsx("path", { d: "M8.6 3.4 5 7l3.6 3.6" }) }));
}
export function IconeFechar() {
    return (_jsx("svg", { ...COMUM, children: _jsx("path", { d: "M3.6 3.6l6.8 6.8M10.4 3.6l-6.8 6.8" }) }));
}
export function IconeDiagnostico() {
    return (_jsx("svg", { ...COMUM, children: _jsx("path", { d: "M1.6 7.6h2.6l1.4-3.4 2.2 6 1.4-2.6h3.2" }) }));
}
export function IconeAtualizar() {
    return (_jsxs("svg", { ...COMUM, children: [_jsx("path", { d: "M12 7a5 5 0 1 1-1.6-3.7" }), _jsx("path", { d: "M12.4 1.6v2.8H9.6" })] }));
}
export function IconeEnquadrar() {
    return (_jsx("svg", { ...COMUM, children: _jsx("path", { d: "M1.8 4.8V1.8h3M9.2 1.8h3v3M12.2 9.2v3h-3M4.8 12.2h-3v-3" }) }));
}
/** Seta que gira 90° quando o item representado está expandido (ver `.camadas__expandir`). */
export function IconeExpandir() {
    return (_jsx("svg", { ...COMUM, children: _jsx("path", { d: "M4.2 2.6 9.6 7l-5.4 4.4" }) }));
}
/** Alerta triangular com exclamação, usado para comunicar risco em operações destrutivas. */
export function IconeAlerta() {
    return (_jsxs("svg", { ...COMUM, width: 20, height: 20, viewBox: "0 0 20 20", children: [_jsx("path", { d: "M10 2.2 18.2 16.8H1.8L10 2.2Z", strokeLinejoin: "round" }), _jsx("path", { d: "M10 8v4" }), _jsx("circle", { cx: "10", cy: "14.6", r: "0.9", fill: "currentColor", stroke: "none" })] }));
}
/** Lata de exclusão, usada em ações destrutivas definitivas. */
export function IconeExcluir() {
    return (_jsxs("svg", { ...COMUM, children: [_jsx("path", { d: "M2.4 3.8h9.2" }), _jsx("path", { d: "M5.2 3.8V2.4h3.6v1.4" }), _jsx("path", { d: "M3.6 3.8 4.2 11.6h5.6l0.6-7.8" }), _jsx("path", { d: "M5.8 6v3.4M8.2 6v3.4" })] }));
}
/** Seta para cima sobre uma bandeja, usada para upload de arquivos. */
export function IconeUpload() {
    return (_jsxs("svg", { ...COMUM, width: 22, height: 22, viewBox: "0 0 22 22", children: [_jsx("path", { d: "M11 14.2V3.4" }), _jsx("path", { d: "M7 7.4 11 3.4l4 4" }), _jsx("path", { d: "M3.6 14.2v3a1.6 1.6 0 0 0 1.6 1.6h11.6a1.6 1.6 0 0 0 1.6-1.6v-3" })] }));
}
export function IconeConfiguracoes() {
    return (_jsxs("svg", { ...COMUM, children: [_jsx("circle", { cx: "7", cy: "7", r: "2.1" }), _jsx("path", { d: "M7 1.4v1.6M7 10.9v1.6M12.6 7H11M3 7H1.4M10.8 3.2l-1.1 1.1M4.3 9.7l-1.1 1.1M10.8 10.8l-1.1-1.1M4.3 4.3 3.2 3.2" })] }));
}
